import router from '../router';
import settings from '@/settings';
import helper from '@/libs/helper';
export function modalSure(title) {
  var _this = this;
  var confirmButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$t('public.ok');
  var tips = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$t('public.tips');
  return new Promise(function (resolve, reject) {
    _this.$confirm("".concat(title || _this.$t('publicjs.title1'), "?"), tips, {
      confirmButtonText: confirmButton,
      cancelButtonText: _this.$t('public.cancel'),
      type: 'warning'
    }).then(function () {
      resolve();
    }).catch(function (action) {
      // this.$message({
      //   type: 'info',
      //   message: this.$t('public.cancelled')
      // })
    });
  });
}

/**
 * @description 短信是否登录
 */
export function wss(wsSocketUrl) {
  var ishttps = document.location.protocol === 'https:';
  if (ishttps) {
    return wsSocketUrl.replace('ws:', 'wss:');
  } else {
    return wsSocketUrl.replace('wss:', 'ws:');
  }
}

/**
 * 跳转页面
 * @param {String} url
 * @param {Object} query
 */
export var pageJumpTo = function pageJumpTo(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  router.push({
    path: settings.roterPre + url,
    query: query
  });
};

/**
 * 修改消息推送页面跳转
 * @param {Object} item
 * @returns {*}
 */
export var toMessageDetailUrl = function toMessageDetailUrl(item) {
  var selectedType = ['delete', 'recall'];
  if (!item.url || selectedType.includes(item.action)) return false;
  pageJumpTo(item.url);
};

/**
 * 文件下载
 * @param {String} url
 * @param {String} name
 * @returns {*}
 */
export var fileLinkDownLoad = function fileLinkDownLoad(url, name) {
  if (!url) return;
  var urlPath = String(url);
  // 后台 https 下 http 附件会被浏览器拦截/忽略 download
  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && urlPath.indexOf('http://') === 0) {
    urlPath = 'https://' + urlPath.substring(7);
  }
  var link = document.createElement('a');
  link.style.display = 'none';
  link.href = urlPath;
  if (name) link.setAttribute('download', name);
  link.setAttribute('target', '_blank');
  link.setAttribute('rel', 'noopener noreferrer');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * 根据文件名称截取返回文件扩展名
 * @param {String} filename
 * @returns {String}
 */
export var getFileExtension = function getFileExtension(filename) {
  return filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
};

/**
 * 判断图片类型
 * @param {String} name
 * @returns {Boolean}
 */
export var isTypeImage = function isTypeImage(name) {
  var fileTypeName = getFileExtension(name);
  return helper.checkImageType.includes(fileTypeName.toLowerCase());
};

/**
 * 根据文件名称获取文件类型和后缀
 * @param {String} fileUrl
 * @returns {String}
 */
export var getFileType = function getFileType(fileUrl) {
  var icon = '';
  var fileType = getFileExtension(fileUrl);
  if (fileType === 'ppt' || fileType === 'pptx') {
    icon = 'iconppt color-ppt';
  } else if (fileType === 'doc' || fileType === 'docx') {
    icon = 'iconwendang1 color-doc';
  } else if (isTypeImage(fileType)) {
    icon = 'img';
  } else if (fileType === 'xls' || fileType === 'xlsx' || fileType === 'xlsm') {
    icon = 'iconbiaoge color-excel';
  } else if (fileType === 'pdf') {
    icon = 'iconpdf color-pdf';
  } else {
    icon = '';
  }
  return icon;
};

/**
 * 转换文件大小
 * @param {Number} bytes
 * @param {Number} decimals
 * @returns {String}
 */
export var formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return '0 Bytes';
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB', 'GB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * 判断类型是否为object
 * @param obj
 * @returns {boolean}
 */
export var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

/**
 * 判断数组中是否包含某值
 * @param {Array} arr
 * @param {Number} value
 * @returns {Boolean}
 */
export var isInArray = function isInArray(arr, value) {
  return arr.includes(value);
};

/**
 * 计算两个时间差(小时分钟)
 * @param {startDate} 开始时间 9:00
 * @param {endDate} 结束时间 18:00
 * @returns {String}
 */
export var getInervalHour = function getInervalHour(startDate, endDate) {
  var dateDiff = endDate - startDate;
  var residue1 = dateDiff % (24 * 3600 * 1000);
  var hours = Math.floor(residue1 / (3600 * 1000));
  var residue2 = residue1 % (3600 * 1000);
  var minutes = Math.floor(residue2 / (60 * 1000));
  return [hours, minutes];
};

/**
 * 计算两个时间差(小时分钟)
 * @param {startDate} 开始时间 9:00
 * @param {endDate} 结束时间 18:00
 * @returns {String}
 */
export var getInervalTwoHour = function getInervalTwoHour(startDate, endDate, start, end) {
  var dateDiff = endDate - startDate - (end - start);
  var residue1 = dateDiff % (24 * 3600 * 1000);
  var hours = Math.floor(residue1 / (3600 * 1000));
  var residue2 = residue1 % (3600 * 1000);
  var minutes = Math.floor(residue2 / (60 * 1000));
  return [hours, minutes];
};
/**
 * 计算两个时间和(小时分钟)
 * @param {startDate} 开始时间 9:00
 * @param {endDate} 结束时间 18:00
 * @returns {String}
 */
export var getHour = function getHour(startDate, endDate, start, end) {
  var dateDiff = endDate - startDate + (end - start);
  var residue1 = dateDiff % (24 * 3600 * 1000);
  var hours = Math.floor(residue1 / (3600 * 1000));
  var residue2 = residue1 % (3600 * 1000);
  var minutes = Math.floor(residue2 / (60 * 1000));
  return [hours, minutes];
};

/**
 * 删除数组中的某值
 * @param {Array} arr
 * @param {Number} value
 * @returns {Array}
 */
export var removeValueFromArray = function removeValueFromArray(arr, value) {
  return arr.filter(function (item) {
    return item !== value;
  });
};

/**
 * 根据filter 数组对象去重
 * @param {Array} array
 * @param {String} filter 过滤参数
 * @returns {Array} {*}
 */
export var removeDuplicateObjects = function removeDuplicateObjects(array) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var uniqueArray = array.reduce(function (accumulator, item) {
    // 使用对象的id作为键来判断是否已经存在
    if (!accumulator[item[filter]]) {
      accumulator[item[filter]] = true;
      accumulator.result.push(item);
    }
    return accumulator;
  }, {
    result: []
  });
  return uniqueArray.result;
};

/**
 * 根据filter 数组差集
 * @param {Array} array1
 * @param {Array} array2
 * @param {String} filter 过滤参数
 * @returns {*}
 */

export var getArrayDifference = function getArrayDifference(array1, array2) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  return array1.filter(function (v) {
    return array2.every(function (val) {
      return val[filter] != v[filter];
    });
  });
};

/**
 * 根据filter 过滤filter集合
 * @param {Array} arr
 * @param {String} filter 过滤参数
 * @returns {*}
 */
export var extractArrayIds = function extractArrayIds(arr) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return arr && arr.length > 0 ? arr.map(function (department) {
    return department[filter];
  }) : [];
};